export const APP_VERSION = "2.3.0";

// Shows when the app was built/released.
// - During `npm run build`, we set `REACT_APP_RELEASE_DATE` automatically.
// - During `npm start` (dev), we fall back to today's date.
const today = new Date();
const fallbackReleaseDate = `${today.getDate()} ${today.toLocaleString("en-US", {
  month: "long",
})} ${today.getFullYear()}`;

export const APP_RELEASE_DATE =
  process.env.REACT_APP_RELEASE_DATE || fallbackReleaseDate;

